module.exports = __webpack_public_path__ + "img/43.b0bba72c.jpg";